import _ from 'lodash'

/**
 * Mixin containing utility methods required to render a one-to-many subform view from a Wizer's DataTable
 * Component using this mixin should have these fields as part of its data:
 * isDirty Boolean
 * show Boolean
 * editableData Array
 */
export default {
  data() {
    return {
      addNewLabel: 'Add New',
    }
  },
  methods: {
    toggleShow() {
      this.editableData = _.cloneDeep(this.editorData)
      this.show = !this.show
      this.isDirty = false
    },
    async onAddClick(validationRefs, validatorFunction, successfulEventName) {
      validationRefs.forEach((validationRef) => this.$refs[validationRef].validate())
      this.$nextTick(async () => {
        let inputContainsValidationError = false

        validationRefs.forEach((validationRef) => {
          if (this.$refs[validationRef].inputError) {
            inputContainsValidationError = true
          }
        })
        if (inputContainsValidationError) {
          // Form contains validation errors, stop saving
          return
        }
        const contextValidationsPassed = await validatorFunction(this.editableData, this.entryIndex)
        if (contextValidationsPassed) {
          // Validation has passed, proceed with data saving
          this.editableData.steps.forEach((step) => {
            delete step.rowProps
            delete step.dataTableId
          })
          this.$emit(successfulEventName, this.editableData, this.entryIndex)
          this.show = false
          this.isDirty = false
        }
      })
    },
  },
  computed: {
    isNewEntry() {
      return this.entryIndex === -1
    },
  },
}
